<script setup lang="ts">
import { computed } from 'vue'
import { useMission } from '~/composables/useMission'
import type { Mission } from '~/types/mission'

const props = defineProps({
  mission: {
    type: Object as () => Mission,
    required: true,
  },
})

const { hasTag } = useMission(props.mission)

const showSticker = computed(() => {
  return hasTag("La tournée d'été")
})
</script>

<template>
  <div v-if="showSticker">
    <img
      src="/images/stickers/sticker-tournee-ete.svg"
      alt="La tournée d'été"
      class="w-[76px] h-auto absolute bottom-2 right-2"
    />
  </div>
</template>
